
import React from 'react'
import { useContext, useState } from 'react'
import NoteContext from '../context/notes/noteContext'

export default function NoteItem({ note, updateNote }) {
    const context = useContext(NoteContext)
    const { deleteNote, editNote } = context


    var utcDate = note.date;  // ISO-8601 formatted date returned from server
    var localDate = new Date(utcDate);
    const dater = localDate.toString()
    const anotherTime = dater.slice(16,21)
    

    let newTime
    const tConv24 = (time24) => {
        var ts = time24;
        var H = +ts.substr(0, 2);
        var h = (H % 12) || 12;
        h = (h < 10) ? ("0" + h) : h;  // leading 0 at the left for 1 digit hours
        var ampm = H < 12 ? " AM" : " PM";
        ts = h + ts.substr(2, 3) + ampm;
        newTime = ts
        return newTime;
    }

    tConv24(anotherTime)


    return (
        <div className='col-md-4 col-lg-3 col-6'>




            <div className="card my-3" >

                <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill text-bg-primary">{note.tag}</span>
                <div className="card-body">
                    <h4 className="card-title">{note.title}</h4>

                    <p className="card-text">{note.description}</p>

                    <div style={{ fontSize: "15px" }}>
                        <p className='form-text' style={{ marginBottom: "0px" }}>{newTime}</p>
                        <p style={{ marginTop: "0px" }} className='form-text'>{dater.slice(0,15)}</p>
                    </div>
                    <div className="d-flex justify-content-around">
                        <div>

                            <i className="fa fa-trash" style={{ fontSize: "30px", color: "#dc3545", cursor: "pointer" }} onClick={() => deleteNote(note._id)} aria-hidden="true"></i>

                        </div>
                        <div>
                            <i onClick={() => updateNote(note._id)} className="fa fa-pencil-square" style={{ fontSize: "30px", color: "royalBlue", cursor: "pointer" }} aria-hidden="true"></i>

                        </div>
                    </div>
                </div>


            </div>


        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/noteItem.jsx